import React, { useState, useEffect } from 'react';
import { Container, Tabs, Tab, Alert } from 'react-bootstrap';
import ProUpgrade from '../components/Pro/ProUpgrade';
import GameSpaceManagement from '../components/Pro/GameSpaceManagement';
import TokenManagement from '../components/Pro/TokenManagement';
import { HostInfo } from '../types';
import gameService from '../services/gameService';

const ProManagement: React.FC = () => {
  const [hostInfo, setHostInfo] = useState<HostInfo | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<string>('upgrade');

  useEffect(() => {
    loadHostInfo();
  }, []);

  const loadHostInfo = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await gameService.getHostInfo();
      
      if (response.success && response.data) {
        setHostInfo(response.data);
        
        // If user is already Pro, switch to the GameSpaces tab
        if (response.data.isPro) {
          setActiveTab('gamespaces');
        }
      } else {
        setError(response.message || 'Failed to load host information');
      }
    } catch (err) {
      setError('An unexpected error occurred while loading host information');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleUpgradeSuccess = (updatedHostInfo: HostInfo) => {
    setHostInfo(updatedHostInfo);
    setActiveTab('gamespaces');
  };

  const handleTokenPurchase = (updatedHostInfo: HostInfo) => {
    setHostInfo(updatedHostInfo);
  };

  return (
    <Container className="mt-4">
      <h2>Pro Account Management</h2>
      
      {error && <Alert variant="danger">{error}</Alert>}
      
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => k && setActiveTab(k)}
        className="mb-4 mt-4"
      >
        <Tab eventKey="upgrade" title="Pro Status">
          <ProUpgrade onUpgradeSuccess={handleUpgradeSuccess} />
        </Tab>
        <Tab eventKey="tokens" title="Token Management">
          <TokenManagement 
            hostInfo={hostInfo || undefined}
            onTokenPurchase={handleTokenPurchase}
          />
        </Tab>
        <Tab eventKey="gamespaces" title="Game Spaces">
          <GameSpaceManagement 
            hostInfo={hostInfo || undefined} 
            onRefresh={loadHostInfo} 
          />
        </Tab>
      </Tabs>
    </Container>
  );
};

export default ProManagement;
